// extracted by mini-css-extract-plugin
export default {"closeWrapper":"CloseModalButton_closeWrapper__TtLx7"};